/**
     * @desc 停用白板
可能产生业务错误码：510001、510002、511001、511005、520003
     */

import * as SWR from 'swr';

import * as defs from '../../baseClass';
import * as Hooks from '../../../hooks';
import { PontCore } from '../../../pontCore';

export class Params {}

export const method = 'POST';

export function mutate(
  params = {},
  newValue = undefined,
  shouldRevalidate = true,
) {
  return SWR.mutate(
    Hooks.getUrlKey(
      '/api/bs-vmeeting/web/v3/meeting/whiteboard/disable',
      params,
      'POST',
    ),
    newValue,
    shouldRevalidate,
  );
}

export function useDeprecatedRequest(params = {}, swrOptions = {}) {
  return Hooks.useRequest(
    '/api/bs-vmeeting/web/v3/meeting/whiteboard/disable',
    params,
    swrOptions,
    { method: 'POST' },
  );
}

export function request(
  params: Params,
  body: defs.api.UserOperationParameters,
  options?: any,
) {
  return PontCore.fetch(
    PontCore.getUrl(
      '/api/bs-vmeeting/web/v3/meeting/whiteboard/disable',
      params,
      'POST',
    ),
    {
      method: 'POST',

      body,
      ...options,
    },
  );
}
